import { render } from "./HealthCare.vue?vue&type=template&id=55e36eed"
import script from "./HealthCare.vue?vue&type=script&lang=js"
export * from "./HealthCare.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__